<template>
    <v-layout
      mt-3
      wrap
    >
      <v-flex v-if="habilitacaoConselhoGetter.st_habilitacao != -1">

        <v-flex mt-2>
          <v-flex
            title
            text--secondary
            mb-3
          >
            Análise da Habilitação
          </v-flex>
            <v-layout
              column
              wrap
              justify-center
            >
              <v-flex
                v-for="item in habilitacaoConselho.conselho.representante.arquivos"
                :key="item.arquivo.co_arquivo"
                md6
              >
                <v-card
                  v-if="item.arquivo.co_arquivo && (!mostrarIndeferidosApenas || (mostrarIndeferidosApenas && item.arquivo.situacaoArquivo.st_situacao === 'IRREGULAR'))"
                  
                  min-height="55"
                  class="elevation-1"
                >
                  <v-layout>
                    <v-flex>
                      <v-flex title text--secondary mt-3 ml-4 >
                          {{ descricaoArquivos[item.tp_arquivo] }}
                      </v-flex>
                    </v-flex>
                    <v-flex
                      xs3
                      sm1
                    >
                      <v-icon
                        large
                        color="blue darken-3"
                        @click="downloadArquivo(item.arquivo.co_arquivo)"
                      >
                        cloud_download
                      </v-icon>
                    </v-flex>
                  </v-layout>
                  <v-flex
                    class="pa-1"
                    ml-4
                  >
                    <v-radio-group
                      v-model="item.arquivo.situacaoArquivo.st_situacao"
                      row
                      disabled
                    >
                      <v-radio
                        label="Regular"
                        class="v-label"
                        value="REGULAR"
                      />
                      <v-radio
                        label="Irregular"
                        class="v-label"
                        value="IRREGULAR"
                      />
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    v-if="item.arquivo.situacaoArquivo.st_situacao === 'IRREGULAR'"
                    pa-3
                  >
                    <v-textarea
                      v-model="item.arquivo.situacaoArquivo.ds_avaliacao"
                      box
                      label="Observação"
                      name="input-7-4"
                      rows="5"
                      row-height="20"
                      no-resize
                      disabled
                    />
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex
          mt-2
        >
          <v-layout>
            <v-flex
            >
              <v-radio-group
                v-model="habilitacaoConselho.st_habilitacao"
                column
                disabled
              >
                <v-radio
                  v-if="habilitacaoConselho.st_habilitacao == codigosConselho.HABILITADO"
                  value="1"
                  color="success"
                >
                  <template v-slot:label>
                    <div><strong class="success--text">Habilitado</strong></div>
                  </template>
                </v-radio>
                <v-radio
                v-if="habilitacaoConselho.st_habilitacao == codigosConselho.NAO_HABILITADO"
                  value="0"
                  color="error"
                >
                  <template v-slot:label>
                    <div><strong class="error--text">Inabilitado</strong></div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-textarea
                v-model="habilitacaoConselho.ds_parecer"
                box
                label="* Parecer"
                name="input-7-4"
                rows="13"
                row-height="28"
                no-resize
                disabled
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import codigosConselho from '../utils/codigosConselho'
import moment from 'moment';

export default {
  name: 'HabilitacaoConselhoDetalhesVisualizacao',
  props:{
    mostrarIndeferidosApenas:{
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
  },
  data() {
    return {
      codigosConselho,
      habilitacaoConselho: {
        conselho:{
          representante:{
            arquivos:[]
          }
        }
      },
      descricaoArquivos: {
        ato_normativo_conselho: 'Ato normativo que constituiu o conselho',
        documento_identificacao_responsavel: 'Documento de identificação do presidente do conselho de cultura (conforme item 2.8 do edital)',
        ata_reuniao_conselho: 'Ata da última reunião ordinária ou extraordinária do conselho',
        cpf_presidente_conselho: 'Documento de Cadastro de Pessoas Físicas (CPF) do presidente do conselho de cultura (conforme item 2.8 do edital)',
        ato_normativo_membro_conselho: 'Ato normativo que designa os atuais membros do conselho de cultura',
      },
    };
  },
  computed: {
    ...mapGetters({
      habilitacaoConselhoGetter: 'conselho/habilitacaoConselho',
    }),
  },
  watch: {
    habilitacaoConselhoGetter(value) {
      this.habilitacaoConselho = value;
    },
  },
  methods: {
    ...mapActions({
      downloadArquivo: 'shared/downloadArquivo',
    }),
  },
  mounted() {
    this.habilitacaoConselho = this.habilitacaoConselhoGetter;
  },
};
</script>
